<div *ngIf="!isViewResult">
  <div [ngSwitch]="question.type">
    <div *ngSwitchCase="'language'">
      <label class="item">{{idx+1}}. {{ question.content }}</label>
      <div *ngFor="let lang of question.options; let i = index;" class="form-check pl-0">
        <label class="form-check-label pl-0">
          {{i+1}}: {{ 'recruit.form-compose.'+lang.value | translate }}        ({{lang.count}})
        </label>
      </div>
    </div>
    <div *ngSwitchCase="'genskills'">
      <label class="item">{{idx+1}}. {{ question.content }}</label>
      <div *ngFor="let skill of question.options; let i = index;" class="form-check pl-0">
        <label class="form-check-label pl-0">
          {{i+1}}: {{ 'recruit.form-compose.'+skill.value | translate }}        ({{skill.count}})
        </label>
      </div>
    </div>
    <div *ngSwitchCase="'custlab'">
      <label class="item">{{idx+1}}. {{ question.content }}</label>
      <div *ngFor="let custom of question.options; let i = index;" class="form-check pl-0">
        <label class="form-check-label pl-0">
          {{i+1}}: {{custom.content}}        ({{custom.count}})
        </label>
      </div>
    </div>
  </div>
    <br>
    <p>{{'controlPanel.criteria.four.number' | translate}}</p>
    <div class="form-inline">
      <span>{{'controlPanel.criteria.four.lowerLimit' | translate}}</span>
      <input type="number"
             name="lowerLang"
             class="form-control mx-2"
             [min]="1"
             [max]="upper"
             [disabled]="statistic"
             [(ngModel)]="lower">
      <span>{{'controlPanel.criteria.four.upperLimit' | translate}}</span>
      <input type="number"
             class="form-control mx-2"
             name="upperLang"
             [min]="lower"
             [max]="7"
             [disabled]="statistic"
             [(ngModel)]="upper">
    </div>
    <p><span>{{numberApp || numberApp == 0 ? numberApp : totalApp}}</span> {{'controlPanel.criteria.applicants' | translate}}</p>
    <div class="form-inline" *ngIf="!statistic">
      <span>{{'controlPanel.criteria.assign' | translate}}</span>
      <input type="number"
             name="score"
             class="form-control mx-2"
             min="0"
             max="99"
             [disabled]="statistic"
             [(ngModel)]="score">
    </div>
    <div style="margin-top: 10px;">
      <button class="btn btn-success" *ngIf="!statistic" (click)="onGetAllResult()">{{'common.update' | translate}}</button>
    </div>
</div>
<div *ngIf="isViewResult">
  <label class="item">{{idx+1}}. {{ question.content }}</label>
  <div *ngFor="let skill of question.options; let i = index;" class="form-check">
    <label class="form-check-label">
      {{i+1}}: {{skill.content}}        ({{skill.count}})
    </label>
  </div>
  <p style="margin-top: 20px;">{{ 'controlPanel.skillQuestion.numberSkillScale' | translate }}</p>
  <b>{{ 'controlPanel.numberQuestion.limitSelected' | translate }}</b>
  <p style="margin-top: 15px;">{{ 'controlPanel.numberQuestion.lowerLimit' | translate }}: <b>{{min}}</b>. {{ 'controlPanel.numberQuestion.upperLimit' | translate }}: <b>{{max}}</b>.</p>
  <p><span>{{applicantsFulfill}}</span> {{'controlPanel.applicantFulfilled' | translate }} <b>{{score}}</b></p>
</div>
<hr>
